import React from 'react';
import {apiV2TransactionsList} from '../../../../../../api/merchant/transactions';

import {TableMerchant} from '../../../../../helpers/Table/';
import {generateActionsList} from "./utils/generateActionsList";
import {columnsList} from "./constants/columnsList";
import {reportGenerationParams} from "./constants/reportGenerationParams";
import {statuses, transactionTypes} from "../../../../../dumb/IntervalFilterCustom";
import {Box} from "@material-ui/core";
import map from "mn-utils/map";

const getRowsFromServer = (terminal_id) => ({offset, limit, ...rest}) => {
  return apiV2TransactionsList({offset, limit, only_terminals: true, terminal_id, ...rest});
};

module.exports = ({terminalId, terminalsList = [], disableFilters}) => {

  const selects = {
    tx_status: statuses
  }

  if (terminalsList.length) {
    selects['terminal'] = {
      name: 'terminal_id',
      placeholder: 'Terminal',
      list: terminalsList,
    }
  }

  return (
    <TableMerchant
      disableFilters={disableFilters}
      filtersParams={{selects}}
      getDataFromServer={getRowsFromServer(terminalId)}
      // report={reportGenerationParams}
      columns={columnsList}
      actions={(row) => (
        generateActionsList(row)
      )}
    />
  )
}
